import React, { Fragment, useEffect } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import Icon from '../Icons/Icon'
import AlertBadge from '../Icons/AlertBadge'
import ErrorBoundary from '../Containers/ErrorBoundary/ErrorBoundary'
import { useModal } from '.'
import { classNames } from '../../Services/helpers'

const TheModal = ({isOpen, title, theme, icon, setIsOpen, children, dismissible, initialFocus, closer: externalCloser, extraBtn, fullHeight = false}) => {
    const {closer, isDismissingPrevented} = useModal();

    let closeHandler = () => null;
    let closeBtn = null;

    closer.listen(() => setIsOpen(false));

    if (dismissible && isDismissingPrevented !== true) {
        closeHandler = () => setIsOpen(false);
        closeBtn = <button
            type="button"
            className="rounded-md bg-white text-slate-400 hover:text-slate-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            onClick={() => setIsOpen(false)}
        >
            <span className="sr-only">Close</span>
            <Icon icon="XMark" size="1x" className="fill-muted" inline aria-hidden="true" />
        </button>
    }

    useEffect(() => {
        if (externalCloser) {
            return externalCloser.listen(() => setIsOpen(false));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [externalCloser]);

    return (<>
        <Transition.Root show={isOpen} as={Fragment} appear="true">
            <Dialog as="div"
                className="relative z-40"
                onClose={closeHandler}
                initialFocus={initialFocus}
            >
                <Transition.Child
                    appear="true"
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 sm:items-center sm:p-0">
                        <Transition.Child
                            appear="true"
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className={classNames(
                                'relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 w-full md:max-w-lg sm:p-6',
                                fullHeight && 'h-[calc(100vh-4rem)]'
                            )}>
                                <div className="absolute right-0 top-0 pr-4 pt-4 flex flex-row items-center gap-4">
                                    {extraBtn}
                                    {closeBtn}
                                </div>
                                <div className="sm:flex sm:items-start h-full">
                                    {icon && <AlertBadge icon={icon} theme={theme} />}
                                    <div className="sm:ml-4 sm:text-left w-full h-full">
                                        <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-brand text-center md:text-left">
                                        {title}
                                        </Dialog.Title>
                                        <div className="mt-2 h-full">
                                            <ErrorBoundary>
                                                {children}
                                            </ErrorBoundary>
                                        </div>
                                    </div>
                                </div>

                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    </>)
}

export default TheModal;
